<template>
  <div>
    <v-row>
      <v-col>
        <BaseLabel
          v-if="!hideLabel"
          :label="$t('attributes.approval.base64_image')"
        />
      </v-col>
      <v-col class="text-right">
        <v-btn text color="primary" @click="clearSignature()">
          <v-icon left>mdi-eraser</v-icon>
          {{ $t('buttons.reset') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-card class="mb-4 text-right">
      <VueSignaturePad
        ref="signaturePad"
        :height="`${height}px`"
        :options="{ onEnd, onBegin }"
      />
    </v-card>
  </div>
</template>

<script>
import localValue from '@/mixins/localValue';
import { VueSignaturePad } from 'vue-signature-pad';

export default {
  mixins: [localValue],
  components: {
    VueSignaturePad,
  },
  props: {
    height: {
      type: [Number, String],
      default: 400,
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async setSignature() {
      const { data } = await this.$refs.signaturePad.saveSignature();
      this.localValue = data;
    },
    onBegin() {
      this.$refs.signaturePad.resizeCanvas();
    },
    async onEnd() {
      this.setSignature();
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.setSignature();
    },
  }
};
</script>

<style lang="scss" scoped />